export enum ActionTypes {
  GET_ALL_USERS = '[User] GetAllUsers',
  GET_USER_STATS = '[User] GetUserStats',
}

export class GetAllUsers {
  static readonly type = ActionTypes.GET_ALL_USERS;
}

export class GetUserStats {
  static readonly type = ActionTypes.GET_USER_STATS;
}
